/* VitaThrive motion — scroll reveals, sticky-header state, gentle parallax.
   Vanilla JS, no dependencies. Respects prefers-reduced-motion. */
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Make the custom VitaThrive pages feel alive without requiring every Liquid
  // block to carry animation attributes by hand.
  function autoMotionTargets() {
    var selectors = [
      [".vt-home-copy .vt-kicker", "left", 0],
      [".vt-home-copy h1", "left", 0.06],
      [".vt-home-copy p", "left", 0.12],
      [".vt-home-actions", "left", 0.18],
      [".vt-home-standards .vt-standard", "fade", 0],
      [".vt-section-head h2", "left", 0],
      [".vt-section-head p", "right", 0.06],
      [".vt-product-grid .vt-product-card", "zoom", 0],
      [".vt-brand-panel h2", "left", 0],
      [".vt-brand-copy > p", "right", 0.06],
      [".vt-brand-point", "fade", 0],
      [".vt-footer-grid > *", "fade", 0],
      [".vt-product-hero > *", "fade", 0],
      [".vt-product-detail-grid > *", "fade", 0],
      [".vt-collection-grid > *", "zoom", 0]
    ];

    selectors.forEach(function (item) {
      [].slice.call(document.querySelectorAll(item[0])).forEach(function (el, i) {
        if (!el.hasAttribute("data-reveal")) el.setAttribute("data-reveal", item[1]);
        if (!el.style.getPropertyValue("--vt-delay")) {
          el.style.setProperty("--vt-delay", (item[2] + i * 0.055).toFixed(2) + "s");
        }
      });
    });
  }

  // Auto-tag children of [data-reveal-group] with a staggered reveal delay.
  function autoStagger() {
    var groups = [].slice.call(document.querySelectorAll("[data-reveal-group]"));
    groups.forEach(function (group) {
      var base = parseFloat(group.getAttribute("data-reveal-group")) || 0;
      [].slice.call(group.children).forEach(function (child, i) {
        if (!child.hasAttribute("data-reveal")) child.setAttribute("data-reveal", "");
        child.style.setProperty("--vt-delay", (base + i * 0.08).toFixed(2) + "s");
      });
    });
  }

  // Reveal-on-scroll using a viewport check (robust across browsers).
  function reveal() {
    var els = [].slice.call(document.querySelectorAll("[data-reveal]"));
    if (!els.length) return;

    if (reduce) {
      els.forEach(function (el) { el.classList.add("vt-in"); });
      return;
    }

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var still = [];
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > -40) {
          el.classList.add("vt-in");
        } else {
          still.push(el);
        }
      });
      els = still;
    }

    check();

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        check();
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    // Safety net for environments that delay layout.
    window.addEventListener("load", function () { setTimeout(check, 150); });
  }

  // Add a state class to the sticky header once the page is scrolled.
  function header() {
    var chrome = document.querySelector("[data-vitathrive-chrome]");
    if (!chrome) return;
    var onScroll = function () {
      chrome.classList.toggle("vt-scrolled", window.pageYOffset > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // Subtle pointer-driven parallax on the hero product stage.
  function heroParallax() {
    if (reduce) return;
    var stage = document.querySelector("[data-vt-parallax]");
    if (!stage) return;
    var layers = [].slice.call(stage.querySelectorAll("[data-depth]"));
    if (!layers.length) return;

    stage.addEventListener("pointermove", function (e) {
      var r = stage.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      var dy = (e.clientY - r.top) / r.height - 0.5;
      layers.forEach(function (layer) {
        var d = parseFloat(layer.getAttribute("data-depth")) || 0;
        layer.style.setProperty("--vt-px", (dx * d * 26).toFixed(1) + "px");
        layer.style.setProperty("--vt-py", (dy * d * 26).toFixed(1) + "px");
      });
    });
    stage.addEventListener("pointerleave", function () {
      layers.forEach(function (layer) {
        layer.style.setProperty("--vt-px", "0px");
        layer.style.setProperty("--vt-py", "0px");
      });
    });
  }

  // Button and link press feedback with a restrained ripple.
  function pressFeedback() {
    var selectors = [
      ".vt-cta",
      ".vt-link",
      ".vt-chrome-link",
      ".vt-product-card",
      ".vt-info-card",
      ".vt-faq-list summary",
      ".vt-add-button",
      ".vt-page-submit",
      ".vt-cart-link",
      ".vt-qty button",
      "[data-vt-step]",
      "[data-vt-remove]"
    ].join(",");

    document.addEventListener("pointerdown", function (e) {
      var target = e.target.closest ? e.target.closest(selectors) : null;
      if (!target || target.classList.contains("is-disabled")) return;
      target.classList.add("vt-pressing");
      if (reduce || target.classList.contains("vt-product-card")) return;

      var rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var ripple = document.createElement("span");
      ripple.className = "vt-ripple";
      var size = Math.max(rect.width, rect.height) * 1.35;
      ripple.style.width = size + "px";
      ripple.style.height = size + "px";
      ripple.style.left = e.clientX - rect.left - size / 2 + "px";
      ripple.style.top = e.clientY - rect.top - size / 2 + "px";
      target.appendChild(ripple);
      window.setTimeout(function () {
        if (ripple.parentNode) ripple.parentNode.removeChild(ripple);
      }, 620);
    }, { passive: true });

    ["pointerup", "pointercancel", "pointerleave"].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var target = e.target.closest ? e.target.closest(selectors) : null;
        if (target) target.classList.remove("vt-pressing");
      }, { passive: true });
    });
  }

  // Mobile hamburger menu toggle.
  function mobileMenu() {
    var chrome = document.querySelector("[data-vitathrive-chrome]");
    var burger = document.querySelector("[data-vt-burger]");
    if (!chrome || !burger) return;
    burger.addEventListener("click", function () {
      var open = chrome.classList.toggle("vt-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    var menu = chrome.querySelector(".vt-mobile-menu");
    if (menu) {
      menu.addEventListener("click", function (e) {
        if (e.target.tagName === "A") {
          chrome.classList.remove("vt-open");
          burger.setAttribute("aria-expanded", "false");
        }
      });
    }
  }

  // Sticky mobile add-to-cart bar: mirror the main add button.
  function stickyAtc() {
    var bar = document.querySelector("[data-vt-sticky-atc]");
    if (!bar) return;
    var mainBtn = document.querySelector(".vt-add-button");
    var trigger = bar.querySelector("button");
    if (mainBtn && trigger) {
      trigger.addEventListener("click", function () { mainBtn.click(); });
    }
    var hero = document.querySelector(".vt-product-hero");
    if (!hero) { bar.classList.add("is-visible"); return; }
    var onScroll = function () {
      var past = hero.getBoundingClientRect().bottom < window.innerHeight * 0.4;
      bar.classList.toggle("is-visible", past);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // Rotating top benefit bar (mobile) so it never looks empty.
  function topbar() {
    var bar = document.querySelector("[data-vt-topbar]");
    if (!bar) return;
    var spans = [].slice.call(bar.querySelectorAll("span"));
    if (spans.length < 2) return;
    var mq = window.matchMedia("(max-width: 860px)");
    var i = 0;
    var timer = null;
    function show(n) {
      spans.forEach(function (s, k) { s.classList.toggle("is-active", k === n); });
    }
    function start() {
      show(0);
      if (reduce || timer) return;
      timer = setInterval(function () { i = (i + 1) % spans.length; show(i); }, 3600);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      spans.forEach(function (s) { s.classList.remove("is-active"); });
    }
    function apply() { if (mq.matches) start(); else stop(); }
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  // Cart: AJAX add-to-cart + fly-to-cart animation + live count.
  function cartFx() {
    var cartLink = document.getElementById("vt-cart-link");

    function setCount(n) {
      [].slice.call(document.querySelectorAll("[data-vt-cart-count]")).forEach(function (el) {
        el.textContent = n;
        if (n > 0) {
          el.removeAttribute("hidden");
          el.classList.remove("is-pulse");
          void el.offsetWidth;
          el.classList.add("is-pulse");
        } else {
          el.setAttribute("hidden", "");
        }
      });
    }

    function refresh() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }

    function fly(src) {
      if (!cartLink || !src || reduce) return;
      var s = src.getBoundingClientRect();
      var d = cartLink.getBoundingClientRect();
      if (!s.width) return;
      var clone = src.cloneNode(true);
      clone.className = "vt-fly";
      clone.style.left = s.left + "px";
      clone.style.top = s.top + "px";
      clone.style.width = s.width + "px";
      clone.style.height = s.height + "px";
      document.body.appendChild(clone);
      var dx = d.left + d.width / 2 - (s.left + s.width / 2);
      var dy = d.top + d.height / 2 - (s.top + s.height / 2);
      requestAnimationFrame(function () {
        clone.style.transform = "translate(" + dx + "px," + dy + "px) scale(0.07)";
        clone.style.opacity = "0.25";
      });
      window.setTimeout(function () {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        if (cartLink) {
          cartLink.classList.remove("is-bump");
          void cartLink.offsetWidth;
          cartLink.classList.add("is-bump");
        }
      }, 920);
    }

    var form = document.getElementById("VitaThriveProductForm");
    if (!form) return;
    var addBtn = form.querySelector(".vt-add-button");
    var galleryImg = document.querySelector(".vt-pdp-gallery img, .vt-product-gallery img");

    function doAdd() {
      if (addBtn && addBtn.hasAttribute("disabled")) return;
      var label = addBtn ? addBtn.textContent : "";
      if (addBtn) { addBtn.textContent = "Adding…"; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          fly(galleryImg);
          refresh();
          if (addBtn) {
            addBtn.textContent = "Added ✓";
            window.setTimeout(function () { addBtn.textContent = label; }, 1600);
          }
        })
        .catch(function () {
          // Fall back to a normal submit if AJAX is unavailable.
          if (addBtn) addBtn.textContent = label;
          HTMLFormElement.prototype.submit.call(form);
        });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      doAdd();
    });
  }

  // Cart page: live AJAX quantity steppers + remove, updating totals in place.
  function cartPage() {
    var form = document.querySelector("[data-vt-cart-form]");
    if (!form) return;

    function money(c) { return "£" + (c / 100).toFixed(2); }

    function apply(cart) {
      var keys = {};
      cart.items.forEach(function (it) { keys[it.key] = it; });
      [].slice.call(document.querySelectorAll(".vt-cart-item")).forEach(function (row) {
        var it = keys[row.getAttribute("data-key")];
        if (!it) {
          row.classList.add("is-removing");
          window.setTimeout(function () { if (row.parentNode) row.remove(); }, 320);
          return;
        }
        var lt = row.querySelector("[data-vt-line-total]");
        if (lt) lt.textContent = money(it.final_line_price);
        var inp = row.querySelector("[data-vt-qty]");
        if (inp) inp.value = it.quantity;
      });
      var sub = document.querySelector("[data-vt-subtotal]");
      if (sub) sub.textContent = money(cart.total_price);
      var tot = document.querySelector("[data-vt-total]");
      if (tot) tot.textContent = money(cart.total_price);
      var ic = document.querySelector("[data-vt-cart-itemcount]");
      if (ic) ic.textContent = cart.item_count;
      [].slice.call(document.querySelectorAll("[data-vt-cart-count]")).forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute("hidden");
        else el.setAttribute("hidden", "");
      });
      if (cart.item_count === 0) window.setTimeout(function () { window.location.reload(); }, 360);
    }

    function change(key, qty) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(apply)
        .catch(function () { HTMLFormElement.prototype.submit.call(form); });
    }

    form.addEventListener("click", function (e) {
      var step = e.target.closest ? e.target.closest("[data-vt-step]") : null;
      var rm = e.target.closest ? e.target.closest("[data-vt-remove]") : null;
      if (step) {
        e.preventDefault();
        var row = step.closest(".vt-cart-item");
        var inp = row.querySelector("[data-vt-qty]");
        var q = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(step.getAttribute("data-vt-step"), 10));
        inp.value = q;
        change(row.getAttribute("data-key"), q);
      } else if (rm) {
        e.preventDefault();
        change(rm.closest(".vt-cart-item").getAttribute("data-key"), 0);
      }
    });

    form.addEventListener("change", function (e) {
      if (e.target.matches && e.target.matches("[data-vt-qty]")) {
        var row = e.target.closest(".vt-cart-item");
        change(row.getAttribute("data-key"), Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });
  }

  // Scroll-driven frame-by-frame product view (canvas image sequence).
  function scroll3d() {
    var section = document.querySelector("[data-vt-scroll3d]");
    if (!section) return;
    var canvas = section.querySelector(".vt-scroll3d-canvas");
    var jsonEl = section.querySelector("[data-vt-3d-frames]");
    var bar = section.querySelector("[data-vt-3d-bar]");
    if (!canvas || !jsonEl) return;

    var urls;
    try { urls = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!urls || !urls.length) return;

    var ctx = canvas.getContext("2d");
    var imgs = new Array(urls.length);
    var current = -1;
    var started = false;

    function draw(i) {
      var img = imgs[i];
      if (img && img.complete && img.naturalWidth) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        current = i;
      }
    }

    function preload() {
      if (started) return;
      started = true;
      urls.forEach(function (u, i) {
        var img = new Image();
        img.decoding = "async";
        img.onload = function () { if (current === -1 && i === 0) draw(0); };
        img.src = u;
        imgs[i] = img;
      });
    }

    function nearViewport() {
      var r = section.getBoundingClientRect();
      return r.top < window.innerHeight * 2 && r.bottom > 0;
    }

    if (reduce) {
      // static representative frame, no scrubbing
      preload();
      var midImg = new Image();
      midImg.onload = function () { ctx.drawImage(midImg, 0, 0, canvas.width, canvas.height); };
      midImg.src = urls[Math.floor(urls.length / 2)];
      return;
    }

    var ticking = false;
    function update() {
      if (nearViewport()) preload();
      var vh = window.innerHeight;
      var total = section.offsetHeight - vh;
      var rect = section.getBoundingClientRect();
      var progress = total > 0 ? -rect.top / total : 0;
      progress = Math.max(0, Math.min(1, progress));
      var idx = Math.round(progress * (urls.length - 1));
      if (idx !== current) draw(idx);
      if (bar) bar.style.width = (progress * 100).toFixed(1) + "%";
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  function init() {
    autoMotionTargets();
    autoStagger();
    reveal();
    header();
    heroParallax();
    pressFeedback();
    mobileMenu();
    stickyAtc();
    cartFx();
    cartPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
